import { CHART_TYPES } from "../utils/chartConfigs";

/**
 * Chart type options for the statistics selector
 */
export const CHART_TYPE_OPTIONS = [
  { value: CHART_TYPES.USERS, label: "Users" },
  { value: CHART_TYPES.SESSIONS, label: "Sessions" },
  { value: CHART_TYPES.VIDEOS, label: "Videos" },
  { value: "subscriptions", label: "All Subscriptions" },
  { value: "recurringSubscriptions", label: "Recurring Subscriptions" },
  { value: "canceledSubscriptions", label: "Canceled Subscriptions" },
  { value: CHART_TYPES.ISSUES, label: "Swing And A Miss" },
  { value: CHART_TYPES.ISSUES_BY_PERCENTAGE, label: "Swing And A Miss by %" },
  { value: CHART_TYPES.ANALYSIS, label: "Analysis" },
  { value: CHART_TYPES.ANALYSIS_BY_PERCENTAGE, label: "Analysis by %" },
  { value: "confidenceScore", label: "Confidence Score" },
  { value: "confidenceScoreByPercentage", label: "Confidence Score by %" },
  { value: CHART_TYPES.SCREEN_RECORDINGS, label: "Screen Recordings" },
];

/**
 * Period options for the period selector
 */
export const PERIOD_OPTIONS = [
  { value: "byDays", label: "By Days" },
  { value: "byWeeks", label: "By Weeks" },
  { value: "byMonths", label: "By Months" },
  { value: "byYears", label: "By Years" },
];

/**
 * Default date ranges for different periods
 */
export const getDefaultDateRange = (period) => {
  const endDate = new Date();
  endDate.setHours(23, 59, 59, 999);
  
  let startDate;
  switch (period) {
    case "byDays":
      startDate = new Date(Date.now() - 14 * 24 * 60 * 60 * 1000);
      startDate.setHours(0, 0, 0, 0);
      return {
        startDate,
        endDate,
        key: "range1",
      };
    case "byWeeks":
      startDate = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000);
      startDate.setHours(0, 0, 0, 0);
      return {
        startDate,
        endDate,
        key: "range1",
      };
    case "byMonths":
      startDate = new Date(Date.now() - 90 * 24 * 60 * 60 * 1000);
      startDate.setHours(0, 0, 0, 0);
      return {
        startDate,
        endDate,
        key: "range1",
      };
    case "byYears":
      startDate = new Date(Date.now() - 1095 * 24 * 60 * 60 * 1000);
      startDate.setHours(0, 0, 0, 0);
      return {
        startDate,
        endDate,
        key: "range1",
      };
    default:
      startDate = new Date(Date.now() - 14 * 24 * 60 * 60 * 1000);
      startDate.setHours(0, 0, 0, 0);
      return {
        startDate,
        endDate,
        key: "range1",
      };
  }
};

